var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mainFrame"}},[_c('Login'),_c('AlertApi')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }